import { Component, input } from '@angular/core';
import { KENDO_LABELS } from "@progress/kendo-angular-label";
import { KENDO_TEXTBOX } from "@progress/kendo-angular-inputs";
import { CommonModule } from '@angular/common';
@Component({
    selector: 'pmis3-vessel-visit-detail-labelled-information',
    standalone: true,
    imports: [CommonModule, KENDO_LABELS, KENDO_TEXTBOX],
    templateUrl: 'vessel-visit-detail-labelled-information.component.html'
})
export class VesselVisitDetailLabelledInformationComponent {
    label = input('');
    value = input<string | number | undefined>('');

    get displayValue() {
        return this.value()?.toString() ?? '-'
    }
}